import React, { useState, useEffect } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const DURATION = 500; // ms

const TestimonialsSection = () => {
  const [active, setActive] = useState(0);
  const [isAuto, setIsAuto] = useState(true);
  const [animating, setAnimating] = useState(false);
  const [incoming, setIncoming] = useState(null);
  const [direction, setDirection] = useState(1); // 1 = вправо->влево (новый с правой), -1 = наоборот

  // css-анимации
  useEffect(() => {
    const ID = 'testimonial-slide-css';
    if (document.getElementById(ID)) return;
    const s = document.createElement('style');
    s.id = ID;
    s.textContent = `
      :root{ --ts-ease: cubic-bezier(.2,.7,.2,1); }
      .ts-leave-left  { animation: tsLeaveLeft  ${DURATION}ms var(--ts-ease) both; }
      .ts-leave-right { animation: tsLeaveRight ${DURATION}ms var(--ts-ease) both; }
      .ts-enter-right { animation: tsEnterRight ${DURATION}ms var(--ts-ease) both; }
      .ts-enter-left  { animation: tsEnterLeft  ${DURATION}ms var(--ts-ease) both; }

      @keyframes tsLeaveLeft  { from{opacity:1;transform:translateX(0)}   to{opacity:0;transform:translateX(-90px)} }
      @keyframes tsLeaveRight { from{opacity:1;transform:translateX(0)}   to{opacity:0;transform:translateX(90px)} }
      @keyframes tsEnterRight { from{opacity:0;transform:translateX(90px)} to{opacity:1;transform:translateX(0)} }
      @keyframes tsEnterLeft  { from{opacity:0;transform:translateX(-90px)}to{opacity:1;transform:translateX(0)} }
    `;
    document.head.appendChild(s);
  }, []);

  const testimonials = [
    {
      id: 1,
      name: 'Mária Kováčová',
      location: 'Bratislava - Petržalka',
      avatar: 'https://images.unsplash.com/photo-1654314694991-10f1a9168612',
      avatarAlt: 'Professional portrait of middle-aged Slovak woman with short brown hair smiling',
      rating: 5,
      date: '2024-09-15',
      project: 'Zasklenie balkóna 12m²',
      testimonial:
        'Úžasná práca! Balkón používame celý rok, aj v zime je tam príjemne. Hluk z ulice sa znížil o 80%. Pánovia boli veľmi profesionálni, prácu dokončili za 2 dni presne podľa dohody. Materiál je kvalitný, všetko perfektne pasuje. Určite odporúčam!',
      afterImage: '../../assets/images/photos/balkon.webp',
      afterAlt: 'Modern glazed balcony',
      benefits: ['Celoročné využitie', 'Zníženie hluku', 'Kvalitné materiály']
    },
    {
      id: 2,
      name: 'Ing. Peter Svoboda',
      location: 'Košice - Sever',
      avatar: 'https://images.unsplash.com/photo-1676275450210-bcc47960ea47',
      avatarAlt: 'Professional headshot',
      rating: 5,
      date: '2024-08-22',
      project: 'Zasklenie terasy 18m²',
      testimonial:
        'Výborná tepelná izolácia! V zime je na terase príjemne teplo, v lete zase chladnejšie. Inštalácia prebehla bez problémov, všetko čisté a presné.',
      afterImage: '../../assets/images/photos/main.webp',
      afterAlt: 'Enclosed terrace',
      benefits: ['Tepelná izolácia', 'Presná práca', 'Dobrá cena']
    },
    {
      id: 3,
      name: 'Dr. Tomáš Moravčík',
      location: 'Žilina - Centrum',
      avatar: 'https://images.unsplash.com/photo-1728819120233-6aa65417e138',
      avatarAlt: 'Portrait of doctor',
      rating: 5,
      date: '2024-07-10',
      project: 'Bezrámové zasklenie 25m²',
      testimonial:
        'Úžasný výhľad bez rušivých rámov! Bezrámové zasklenie je skutočne prémiové riešenie. Kvalita na najvyššej úrovni.',
      afterImage: '../../assets/images/photos/balkon3.webp',
      afterAlt: 'Elegant glazed penthouse balcony',
      benefits: ['Bezrámový dizajn', 'Prémiová kvalita', 'Zvýšenie hodnoty']
    },
    {
      id: 4,
      name: 'Jana Vargová',
      location: 'Nitra - Chrenová',
      avatar: 'https://images.unsplash.com/photo-1708127851232-d1a1bcbd5449',
      avatarAlt: 'Friendly portrait',
      rating: 4,
      date: '2024-09-28',
      project: 'Štandardné zasklenie 8m²',
      testimonial:
        'Rýchla inštalácia za jeden deň! Spokojnosť s kvalitou aj cenou. Balkón je konečne využiteľný.',
      afterImage: '../../assets/images/photos/balkon4.webp',
      afterAlt: 'Protected apartment balcony',
      benefits: ['Rýchla inštalácia', 'Dobrá cena', 'Praktické riešenie']
    }
  ];

  useEffect(() => {
    if (!isAuto || animating) return;
    const id = setInterval(() => {
      const next = (active + 1) % testimonials.length;
      startTransition(next, 1);
    }, 8000);
    return () => clearInterval(id);
  }, [isAuto, animating, active, testimonials.length]);

  const renderStars = (rating = 0) =>
    Array.from({ length: 5 }, (_, i) => (
      <span
        key={i}
        aria-hidden="true"
        className={i < rating ? 'text-[var(--color-warning)]' : 'text-[var(--color-border)]'}
        style={{ lineHeight: 1 }}
      >
        ★
      </span>
    ));

  const startTransition = (targetIndex, dirHint = null) => {
    if (animating || targetIndex === active) return;
    const dir =
      dirHint !== null
        ? dirHint
        : targetIndex > active || (active === testimonials.length - 1 && targetIndex === 0)
        ? 1
        : -1;

    setDirection(dir);
    setIncoming(targetIndex);
    setAnimating(true);

    window.setTimeout(() => {
      setActive(targetIndex);
      setIncoming(null);
      setAnimating(false);
    }, DURATION);
  };

  const handleBulletClick = (i) => {
    setIsAuto(false);
    startTransition(i);
    window.setTimeout(() => setIsAuto(true), 10000);
  };

  const current = testimonials[active];
  const incomingItem = incoming != null ? testimonials[incoming] : null;

  const renderSlide = (t) => {
    const photo = t?.afterImage;
    const photoAlt = t?.afterAlt || t?.project;

    return (
      // было: "grid lg:grid-cols-2 h-full"
      <div className="grid lg:grid-cols-2 h-full grid-rows-[auto,1fr] lg:grid-rows-1">
        {/* Text — на мобилке второй */}
        <div className="order-2 lg:order-1 p-6 md:p-8 lg:p-12 h-full min-h-0 flex flex-col">
          <div className="flex items-center space-x-4 mb-4 md:mb-6">
            <Image src={t?.avatar} alt={t?.avatarAlt} className="w-14 h-14 md:w-16 md:h-16 rounded-full object-cover" />
            <div>
              <h3 className="text-lg md:text-xl font-heading font-semibold text-primary">{t?.name}</h3>
              <div className="flex items-center space-x-2 text-text-secondary text-sm">
                <Icon name="MapPin" size={14} />
                <span>{t?.location}</span>
              </div>
              <div className="flex items-center space-x-2 mt-1">
                <div className="flex items-center space-x-1">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <span key={i} className="text-[var(--color-warning)]" style={{ lineHeight: 1 }}>★</span>
                  ))}
                </div>
                <span className="text-sm text-text-secondary">{new Date(t?.date).toLocaleDateString('sk-SK')}</span>
              </div>
            </div>
          </div>

          {/* эта зона скроллится, когда текст длинный */}
          <div className="flex-1 pr-2">
            <div className="text-sm text-accent font-semibold mb-2">{t?.project}</div>
            <blockquote className="text-base md:text-lg text-text-secondary font-body leading-relaxed italic">
              "{t?.testimonial}"
            </blockquote>

            <div className="flex flex-wrap gap-2 mt-4">
              {t?.benefits?.map((b, i) => (
                <span key={i} className="bg-success/10 text-success px-3 py-1 rounded-full text-sm font-medium">
                  {b}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Photo — на мобилке сверху с явной высотой; на десктопе как было */}
        <div className="relative order-1 lg:order-2 h-48 sm:h-56 md:h-64 lg:h-full">
          <Image
            src={photo}
            alt={photoAlt}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent pointer-events-none" />
        </div>
      </div>
    );
  };

  return (
    <section className="py-20 bg-gradient-to-br from-muted to-background">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-success/10 text-success px-4 py-2 rounded-full mb-6">
            <Icon name="MessageSquare" size={20} />
            <span className="font-semibold">Hodnotenia zákazníkov</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-6">
            Čo hovoria naši zákazníci
          </h2>
          <p className="text-xl text-text-secondary font-body max-w-3xl mx-auto leading-relaxed">
            Prečítajte si skutočné hodnotenia od spokojných zákazníkov po celom Slovensku. Každý projekt je pre nás dôležitý.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {[
            { number: '2000+', label: 'Spokojných zákazníkov', icon: 'Users' },
            { number: '4.9/5', label: 'Priemerné hodnotenie', icon: 'Star' },
            { number: '24', label: 'Rokov skúseností', icon: 'Award' },
            { number: '98%', label: 'Odporúčaní zákazníkmi', icon: 'ThumbsUp' }
          ].map((s, i) => (
            <div key={i} className="text-center bg-white rounded-xl p-6 shadow-lg border border-border">
              <div className="w-12 h-12 bg-accent rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name={s.icon} size={24} color="white" />
              </div>
              <div className="text-3xl font-heading font-bold text-primary mb-2">{s.number}</div>
              <div className="text-sm text-text-secondary font-body">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Main card — ФИКСИРОВАННАЯ ВЫСОТА */}
        <div className="bg-white rounded-2xl shadow-xl border border-border overflow-hidden mb-12">
          {/* фиксим высоту карточки на брейкпоинтах */}
          <div className="relative h-[520px] md:h-[500px] lg:h-[520px]">
            {/* Current (leaving) */}
            <div className={`absolute inset-0 ${animating ? (direction === 1 ? 'ts-leave-left' : 'ts-leave-right') : ''}`}>
              {renderSlide(current)}
            </div>

            {/* Incoming (entering) */}
            {animating && incomingItem && (
              <div className={'absolute inset-0 ' + (direction === 1 ? 'ts-enter-right' : 'ts-enter-left')}>
                {renderSlide(incomingItem)}
              </div>
            )}

            {/* без анимации показываем текущий статично */}
            {!animating && (
              <div className="absolute inset-0">
                {renderSlide(current)}
              </div>
            )}
          </div>
        </div>

        {/* Bullets */}
        <div className="flex justify-center space-x-4 mb-8">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => handleBulletClick(i)}
              className={`w-4 h-4 rounded-full transition-smooth ${active === i ? 'bg-accent' : 'bg-border hover:bg-accent/50'}`}
              aria-label={`Zobraziť hodnotenie ${i + 1}`}
            />
          ))}
        </div>

        {/* Mini-cards — тоже одна высота */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.slice(0, 3).map((t) => (
            <div key={t.id} className="bg-white rounded-xl p-6 shadow-lg border border-border h-[240px] flex flex-col">
              <div className="flex items-center space-x-3 mb-3">
                <Image src={t.avatar} alt={t.avatarAlt} className="w-12 h-12 rounded-full object-cover" />
                <div>
                  <h4 className="font-semibold text-primary">{t.name}</h4>
                  <div className="flex items-center space-x-1">{renderStars(t.rating)}</div>
                </div>
              </div>

              <blockquote
                className="text-text-secondary font-body text-sm leading-relaxed mb-3 overflow-hidden"
                style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 4,
                  WebkitBoxOrient: 'vertical'
                }}
              >
                "{t.testimonial}"
              </blockquote>

              <div className="mt-auto flex items-center justify-between text-xs text-text-secondary">
                <span>{t.location}</span>
                <span>{new Date(t.date).toLocaleDateString('sk-SK')}</span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <div className="bg-gradient-to-r from-accent to-primary rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-heading font-bold mb-4 text-white">Pridajte sa k spokojným zákazníkom</h3>
            <p className="text-white/90 font-body mb-6 max-w-2xl mx-auto">
              Získajte bezplatný cenový odhad a zistite, prečo si nás vybralo už viac ako 2000 zákazníkov.
            </p>
            <button
              onClick={() => {
                const el = document.querySelector('#quote-form');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white text-primary px-8 py-3 rounded-lg font-semibold hover:bg-white/90 transition-smooth inline-flex items-center space-x-2"
            >
              <Icon name="Calculator" size={20} />
              <span>Získať ponuku zadarmo</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;